import { Component, Input } from "@angular/core";
import { DataTableDirective } from "./data-table.directive";

@Component({
	selector: "app-bootstrap-paginator",
	standalone: false,
	template: `
	<app-paginator
		#p
		[mfTable]="mfTable"
	>
	@if (p.dataLength) {
	<div class="row py-3">
		<div class="col-12 col-lg-6">
			<app-paginator-pages [mfTable]="mfTable" />
		</div>
		<div class="col-12 col-lg-6 pe-3 text-end">
			<app-paginator-rows
				[mfTable]="mfTable"
				[rowsOnPageSet]="rowsOnPageSet"
			/>
		</div>
	</div>
	}
</app-paginator>
`
})
export class BootstrapPaginatorComponent {
	@Input() rowsOnPageSet: number[] = [];
	@Input() mfTable: DataTableDirective;
}